import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import PlatformMobileCarousel from "../carousels/PlatformMobileCarousel";
import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";

export default function PlatformGrid({ platforms }) {
  const [selected, setSelected] = useState(null);

  return (
    <>
      <PlatformMobileCarousel
        platforms={platforms}
        onSelect={(idx) => setSelected(idx)}
      />

      <div className="px-6 mt-8 hidden md:grid md:grid-cols-3 gap-6">
        {platforms.map((item, idx) => (
          <motion.div
            key={idx}
            layoutId={`card-${idx}`}
            className="p-6 flex flex-col gap-3 bg-white rounded-2xl shadow hover:shadow-lg cursor-pointer"
            onClick={() => setSelected(idx)}
          >
            <div className="font-semibold text-lg">{item.title}</div>
            <div className="text-sm text-slate-600">{item.desc}</div>
          </motion.div>
        ))}
      </div>

      <AnimatePresence>
        {selected !== null && (
          <motion.div
            className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center p-6 z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelected(null)}
          >
            <motion.div
              layoutId={`card-${selected}`}
              className="bg-white rounded-2xl p-8 max-w-lg w-full shadow-xl relative"
              onClick={(e) => e.stopPropagation()}
            >
              <Button
                onClick={() => setSelected(null)}
                className="absolute right-[10px] top-[10px]"
                type="text"
                icon={<CloseOutlined />}
              />
              <h3 className="text-xl font-semibold">
                {platforms[selected].extraContent?.title}
              </h3>
              <p className="mt-4 text-slate-600 leading-relaxed">
                {platforms[selected].desc}
              </p>

              <ul className="list-disc pl-5 space-y-2 mt-4 text-slate-600 leading-relaxed">
                {platforms[selected].extraContent?.data?.map(text => {
                  return <li>{text}</li>
                })}
              </ul>
              {/* <button
                className="mt-6 px-4 py-2 rounded-lg bg-slate-900 text-white"
                onClick={() => setSelected(null)}
              >
                Close
              </button> */}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
